import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";

const CustomTextField = ({
  label,
  value,
  onChange,
  required,
  maxLength,
  textColor,
  inputColor,
  height,
  width,
  disabled,
  backgroundColor,
  borderRadius,
  ...restProps
}) => {
  const handleInputChange = (e) => {
    if (maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }

    if (onChange) {
      onChange(e);
    }
  };

  const characterCount = maxLength && value ? maxLength - value.length : null;

  const renderLabel = () => {
    const capitalizedLabel = label
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    return (
      <>
        {capitalizedLabel}
        {required && <span style={{ color: "red" }}>*</span>}
      </>
    );
  };

  return (
    <>
      <TextField
        label={renderLabel()}
        fullWidth
        value={value}
        onChange={handleInputChange}
        margin="normal"
        disabled={disabled}
        style={{
          height: height || "auto",
          width: width || "100%",
          backgroundColor: backgroundColor || "white",
          borderRadius: borderRadius || "4px",
        }}
        InputLabelProps={{
          style: { color: textColor || "inherit" },
        }}
        InputProps={{
          style: { color: inputColor || "inherit" },
          height: height || "auto",
          borderRadius: borderRadius || "4px",
        //   endAdornment: (
        //     <div style={{ position: "absolute", right: "16px", bottom: "12px", color: "gray" }}>
        //       {characterCount !== null && `${value.length}/${maxLength}`}
        //     </div>
        //   ),
        }}
        {...restProps}
      />
      {/* {characterCount !== null && (
        <div style={{ marginTop: "8px", color: characterCount < 0 ? "red" : "inherit" }}>
          Character Count: {characterCount}
        </div>
      )} */}
    </>
  );
};

CustomTextField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string, // Assuming value is a string, adjust if it's a different type
  onChange: PropTypes.func,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  textColor: PropTypes.string,
  inputColor: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.string,
  icon: PropTypes.elementType,
  disabled: PropTypes.bool,
};

export default CustomTextField;
